import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import AuthService from './services/authService'
import DashboardService from './services/dashboardService'
import AdminService from './services/adminService'
import UserService from './services/userService'
import ReleaseService from './services/releaseService'
import BlogService from './services/blogService'
import ContactQueryService from './services/contactQueryService'
import NewsletterService from './services/newsletterService'
import HomepageBannerService from './services/homepageBannerService'
import YoutubeBannerService from './services/youtubeBannerService'
import YoutubeMusicService from './services/youtubeMusicService'
import SubmissionService from './services/submissionService'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: ''
  },
  mutations: {
    api_request (state) {
      state.status = 'loading'
    },
    api_error (state) {
      state.status = 'error'
    },
    api_success (state) {
      state.status = 'success'
    }
  },
  actions: {
    catchHandler ({ commit }) {
      commit('api_error')
      commit('empty_state')
      localStorage.removeItem('token')
      localStorage.removeItem('admin')
      delete axios.defaults.headers.common['Authorization']
    }
  },
  getters: {
    apiStatus: state => state.status
  },
  modules: {
    AuthService,
    DashboardService,
    AdminService,
    UserService,
    ReleaseService,
    BlogService,
    ContactQueryService,
    NewsletterService,
    HomepageBannerService,
    YoutubeMusicService,
    YoutubeBannerService,
    SubmissionService
  }
})



// WEBPACK FOOTER //
// ./src/store.js